import { ItemSortEnum as NftSort } from "@rarible/marketplace-backend-v6-client/build"
import type { NftMiniature } from "../types"

export { NftSort }

export enum StatusFilterOption {
  ALL = "all",
  BUY_NOW = "buyNow",
}

export enum RarityFilterOption {
  ALL = "top100",
  TOP_1_PERCENT = "top1",
  TOP_10_PERCENT = "top10",
  TOP_25_PERCENT = "top25",
}

export const AVAILABLE_NFT_SORTS = [
  NftSort.LOW_PRICE_FIRST,
  NftSort.HIGH_PRICE_FIRST,
  NftSort.LATEST,
  NftSort.RECENTLY_LISTED,
  NftSort.RECENTLY_RECEIVED,
  NftSort.RAREST_FIRST,
  NftSort.RAREST_LAST,
] as const

export type AvailableNftSort = (typeof AVAILABLE_NFT_SORTS)[number]

/** Whether a sort orders by price; no sort means price. */
export function isPriceSort(sort: NftSort | undefined): boolean {
  return (
    sort === undefined ||
    sort === NftSort.LOW_PRICE_FIRST ||
    sort === NftSort.HIGH_PRICE_FIRST
  )
}

/** Whether a sort is ordered by the listing itself: by price or listing date. */
export function isListingSort(sort: NftSort | undefined): boolean {
  return isPriceSort(sort) || sort === NftSort.RECENTLY_LISTED
}

/**
 * Whether a grid is about listings: sorted by the listing, or showing listings
 * alone (buy now). Only then does the BFF append mints listed only on other
 * marketplaces to a collection grid, and the client move a row whose listing
 * expired after load to the end. Any other grid ("Most rare", "Latest", … over
 * every item) follows the server's order whether or not a row is listed: a
 * listed rank 80 must not jump above an unlisted rank 1.
 */
export function ordersListedFirst(
  sort: NftSort | undefined,
  status: StatusFilterOption | undefined,
): boolean {
  return status === StatusFilterOption.BUY_NOW || isListingSort(sort)
}

export type NftSearchItem = NftMiniature
